<template>
    <Tag
        icon="ai"
        color-class="ring-orange-100 bg-orange-50 text-yellow-500"
        v-bind="$attrs"
    ></Tag>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import Tag from '@components/Tag/Tag.vue';

export default defineComponent({
    /**
     * This is a tag component that works as a standard component for Ai Content. It has the standard design confiigurations for such a tag
     */
    name: 'TagAI',
    components: {
        Tag,
    },
    inheritAttrs: false,
});
</script>
